<template>
  <div :class="[classes, 'qa-FooterServices']" :data-preload="[$options.name]">
    <div
      role="heading"
      aria-level="2"
      class="headline qa-FooterServices__headline"
      @click="expandHandler"
    >
      <ArrowDropDownSvg
        :class="['headlineIcon', { rotateArrow: expandList }]"
        width="7"
        height="8"
      />
      {{ title }}
    </div>

    <TransitionExpand
      class="items qa-FooterServices__itemsInner"
      :expand="expandList"
      max="768"
    >
      <div
        v-for="(item, index) in providers"
        :key="index"
        class="item qa-FooterServices__item"
      >
        <Icon
          :name="item.icon || item"
          height="30"
          width="70"
          :alt="item.title ? item.title : item"
          :class="setClasses(item)"
          :original="true"
          :inline="showTitle(item)"
          :lazy="!showTitle(item)"
        />
        <span v-if="showTitle(item)" class="itemTitle">
          {{ item.title }}
        </span>
      </div>
    </TransitionExpand>
  </div>
</template>

<script>
import Icon from 'Components/00-generated/Icon';
import ArrowDropDownSvg from 'Components/00-generated/ArrowDropDownSvg';
import TransitionExpand from 'Components/01-atoms/transition-expand/TransitionExpand';
import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'FooterServices',
  components: {
    TransitionExpand,
    Icon,
    ArrowDropDownSvg,
  },
  mixins: [globalMixin],
  props: {
    type: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    providers: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    expandList: false,
  }),
  methods: {
    showTitle: (item) =>
      [
        'stored_creditcard',
        'prepayment',
        'cash_on_delivery',
        'b2b_cash_on_delivery',
        'business_to_business_invoice',
      ].includes(item.icon),
    setClasses(item) {
      const classes = [
        ['prepayment', 'cash_on_delivery', 'b2b_cash_on_delivery', 'stored_creditcard'].includes(
          item.icon
        )
          ? 'genericIcon'
          : 'itemIcon',
      ];

      if (item.icon === 'postnord') {
        classes.push('expanded');
      }

      return classes;
    },
    expandHandler() {
      const mediumMax = window.matchMedia('(max-width: 768px)').matches;
      if (mediumMax) {
        this._data.expandList = !this._data.expandList;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import 'variables/breakpoints';
@import 'mixins';

.headline {
  display: flex;
  align-items: center;

  font-weight: bold;
  font-size: 18px;
  color: var(--color-mine-shaft);
  line-height: 30px;
}

.headlineIcon {
  margin-right: 8px;

  transform: rotate(0);
  transform-origin: center;
  transition: transform var(--time-S) ease-in-out;

  ::v-deep path {
    fill: var(--color-primary);
  }
}

.rotateArrow {
  transform: rotate(-180deg);
}

.items {
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 4px 32px 12px 0;

  background: var(--color-white);
}

.itemIcon {
  max-height: 30px;
  max-width: 70px;
  height: auto;

  &.expanded {
    max-width: 110px;
    width: 110px !important;
  }

  &.gray {
    filter: grayscale(100%);
    opacity: 0.9;
  }
}

.genericIcon,
.itemTitle {
  fill: var(--color-rolling-stone);
  opacity: 0.9;
}

.itemTitle {
  margin-top: 4px;
  font-size: var(--font-size-S);
  color: var(--color-rolling-stone);
}

.itemLabel {
  margin-top: 8px;
  font-size: var(--font-size-S);
  color: var(--color-rolling-stone);
}

@media #{$_mediaMDown} {
  .footerServices {
    padding: 0 8px;
    border-bottom: 1px solid var(--color-alto);

    &--open {
      .headlineIcon {
        transform: rotate(-180deg);
      }
    }
  }

  .headline {
    padding: 8px 0;
    font-size: var(--font-size-SM);
    cursor: pointer;
  }

  .items {
    padding: 0 var(--space-2) var(--space-2);
  }
}

@media #{$_mediaLUp} {
  .headlineIcon {
    display: none;
  }

  .items {
    max-height: none !important;
  }
}
</style>
